import { mapActions,mapState,mapGetters } from 'vuex';
import NotificationMixin from './NotificationMixin';

export default {
  data: () => ({
    images: {},
    blob: null,
    imageExist: 'init',
    componentKey: 0,
    componentKeys: {},
  }),
  mixins: [NotificationMixin],
  mounted() {

  },
  computed: {
    ...mapState('mediaobject', {
      updatedataMediaObject: 'updatedata',
      uploadedMediaObject: 'uploaded',
      errorImage: 'error',
      isLoadingMediaObject: 'isLoading',
    }),
    ...mapGetters('mediaobject',{
      dataImage: 'data',
      downloadingImageReference: 'downloadingImageReference',
    }),
    imageurlItem:  {
      get() {
        return this.getImageUrl(this.item['@id']);
      },
      set(value) { this.images[this.item['@id']] = value; }
    },
    hasImage() {
      return this.hasImageMet();
    },
    hasVideo() {
      if (this.item['image']) {
        if (this.item['image'].filePath.includes('.mp4')) {
          return true;
        }
      }
      return false;
    },
    componentKeyId() {

      return objectid => {
       return this.componentKeyIdMethod(objectid);
     }

    },
    blobFile:  {
      get() {
        return this.blob;
      },
      set(value) { this.blob = value; }
    },
  },
  methods: {
    ...mapActions({
      mediaobjectGetData: 'mediaobject/data',
      mediaobjectPushDownloadImage: 'mediaobject/downloadImage',
      mediaobjectPushDownload: 'mediaobject/download',
      mediaobjectPushDownloadBlob: 'mediaobject/downloadBlob',

      mediaobjectPushUpload: 'mediaobject/upload',
      mediaobjectPushDelete: 'mediaobject/deleteImage',
    }),
    componentKeyIdMethod(objectid) {
      if(this.componentKeys[objectid] !== 'undefined' ) {
        this.componentKeys[objectid] = 0;
      }
      return this.componentKeys[objectid];
    },
    getItemImageKey(item) {
      if (item['image']) {
        return this.componentKeyId(item['image']['@id']);
      } else {
        return 1
      }
    },
    hasImageMet() {
      if (this.imageExist == 'init') {
        if (this.item['image']) {
          this.imageExist =true;
        } else {
          this.imageExist =false;
        }
      }
      return this.imageExist;
    },
    getImageUrl(reference) {
      if (this.hasImageMet()) {
        if (! this.images[reference]) {
          if (! this.downloadingImageReference(reference) ) {
            this.mediaobjectPushDownloadImage({'reference' : this.item['@id'],  'id' : this.item['id'], 'entity' : this.item['@entity'], 'filter' : this.filter });
            this.images[reference] = this.dataImage(reference);
          }
        }
        return this.images[reference];
      }
      return null;
    },
    getImageUrlByObject(object) {
        if(! object['image']) {
          return "";
        }
        if (! this.images[object['image']['@id']]) {
          if (! this.downloadingImageReference(object['image']['@id']) ) {
            this.mediaobjectPushDownloadImage({'reference' : object['image']['@id'],  'id' : object['id'], 'entity' : object['@entity'], 'filter' : this.filter });
            this.images[object['image']['@id']] = this.dataImage(object['image']['@id']);
          }
        }
        console.log(this.images[object['image']['@id']]);
        return this.images[object['image']['@id']];
    },
    downloadItem() {
      let name = this.item['image'].filePath;
      this.mediaobjectPushDownload({ 'id' : this.item['id'], 'entity' : this.item['@entity'] , 'name' : name});
    },
    uploadItem() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        if (this.inputfile) {
          this.mediaobjectPushUpload({ 'id' : this.item['id'], 'entity' : this.item['@entity'] , 'file' : this.inputfile });
      //    this.mediaobjectPushDownloadImage({'reference' : this.item['@id'],  'id' : this.item['id'], 'entity' : this.item['@entity'], 'filter' : this.filter });
      //    this.images[this.item['@id']] = this.dataImage(this.item['@id']);
          this.item['uploadedimg'] = true;
          this.dialogImage = false;

        }
      }

    },
    uploadFileCreateItem(id,entity,inputfile,filter='') {
      if (id && entity && inputfile) {
        this.item['uploadedimg'] = false;
        this.mediaobjectPushUpload({ 'id' : id, 'entity' : entity , 'file' : inputfile , 'filter' : filter});
      }
    },
    downloadFile(namecustom) {
      let name = this.item['file'].filePath;
      if (this.item['name']) {
        let extension = this.item['file'].filePath.split('.').pop();
        if (namecustom && namecustom != '') {
          console.log(namecustom);
          name = namecustom +'.'+ extension;
        } else {
          name = this.item['name'] +'.'+ extension;
        }
        console.log(name);
      }
      this.mediaobjectPushDownload({ 'id' : this.item['id'], 'entity' : this.item['@entity'] , 'name' : name , 'filter' : 'file' });
    },
    downloadFileByObject(object) {
      let name = object['file'].filePath;
      if (object['name']) {
        let extension = object['file'].filePath.split('.').pop();
        name = object['name'] +'.'+ extension;
      }
      this.mediaobjectPushDownload({ 'id' : object['id'], 'entity' : object['@entity'] , 'name' : name , 'filter' : 'file' });
    },
    downloadFileBlob() {
      this.mediaobjectPushDownloadBlob({ 'id' : this.item['id'], 'entity' : this.item['@entity'] , 'name' : this.item['file'].filePath , 'filter' : 'file' });
    },
    downloadFileBlobByObject(object) {
      this.mediaobjectPushDownloadBlob({ 'id' : object['id'], 'entity' : object['@entity'] , 'name' : object['file'].filePath , 'filter' : 'file' });
    },
    downloadFileList(id,entity,filePath, filename) {
      let name = filePath;
      if (filename) {
        let extension = filePath.split('.').pop();
        name = filename +'.'+ extension;
      }
      this.mediaobjectPushDownload({ 'id' : id, 'entity' : entity , 'name' : name , 'filter' : 'file'});
    },
    downloadImageList(id,entity,filePath) {
      this.mediaobjectPushDownload({ 'id' : id, 'entity' : entity , 'name' : filePath , 'filter' : ''});
    },
    deleteFile() {
      this.mediaobjectPushDelete({ 'id' : this.item['id'], 'entity' : this.item['@entity'] });
      this.dialogImage = false;
    },
    forceRerender(objectid) {
      if (this.componentKeys[objectid] !== 'undefined') {
        this.componentKeys[objectid] += 1;
        this.componentKeys = { ...this.componentKeys };
      }
      this.componentKey += 1;
    }

  },
  watch: {
    errorImage(message) {
      if (message == 'NotConnected') {
        console.log(403);
        this.$root.isConnected = false;
        this.$root.passwordTurnover = false;
        if (! this.$root.originalUrlConnected) this.$root.originalUrlConnected = this.$route;
        if(this.$route.name != 'RegenPassword') this.$router.push({ name: `Login` });
      }else {
        message && this.showError(message);
      }
    },
    uploadedMediaObject() {
      if (this.item['uploadedimg']) {
        this.mediaobjectPushDownloadImage({'reference' : this.item['@id'],  'id' : this.item['id'], 'entity' : this.item['@entity'], 'filter' : this.filter });
        this.images[this.item['@id']] = this.dataImage(this.item['@id']);
      }
      this.showMessage(`${this.$t('global.file')} ${this.$t('global.uploaded')}`);
      //console.log(data);f
    },
    updatedataMediaObject: function (updatedataMediaObject) {
      this.images[updatedataMediaObject.id] = this.dataImage(updatedataMediaObject.id);
      if (this.item) {
        if(this.item['file']) {
          //stl
          if (updatedataMediaObject.id == this.item['file'].filePath) {
            this.blobFile = updatedataMediaObject.data;
          }
        }

        //image
        if (!updatedataMediaObject) {
          this.imageExist =false;
          this.imageurlItem = null;
        //  this.forceRerender();
        } else {
          if (updatedataMediaObject.id == this.item['@id']) {
            this.imageExist =true;
            var newImg = {};
            for (const reference in this.images) {
              if(reference == updatedataMediaObject.id) {
                newImg[reference] = updatedataMediaObject.data;
              }else {
                newImg[reference] = this.images[reference];
              }
            }
            this.images = newImg;
            this.imageurlItem = updatedataMediaObject.data;
          //  this.forceRerender();
          } else {
            this.imageExist =false;

          }
        }

      }
      this.forceRerender(updatedataMediaObject.id);
      
    },


  }
};
